import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useContactForm = (t) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    type: '',
    message: '',
    language: t.language || 'fr'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      type: '',
      message: '',
      language: t.language || 'fr'
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const submissionData = {
        ...formData,
        language: t.language || 'fr'
      };
      
      const response = await axios.post(`${BACKEND_URL}/api/contact`, submissionData);
      
      if (response.data.success) {
        toast.success(response.data.message);
        resetForm();
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Error submitting contact form:', error);
      }
      toast.error(t.contact.form.error || 'Une erreur s\'est produite. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formData,
    isSubmitting,
    handleChange,
    handleSubmit
  };
};
